import * as React from "react"
import colors from "../../theme/colors"

const Facebook: React.SFC<{ hovered?: boolean }> = ({ hovered = false }) => (
  <svg width={36} height={36}>
    <path
      d="M36 0v36h-9.839V21.765h4.181l.553-5.23v.001h-4.733v-2.759c.012-1.272.199-1.956 2.081-1.956h2.615v-5.23h-4.181c-5.028 0-6.796 2.542-6.796 6.796v3.149H16.75v5.23h3.131V36H0V0h36z"
      fill={
        hovered
          ? colors.main.accentColor.PRIMARY
          : colors.main.backgroundColor.PRIMARY
      }
      fillRule="evenodd"
    />
  </svg>
)

export default Facebook
